export const RESET = 'TRADES/RESET'
export const SET_SUBSCRIBED = 'TRADES/SET_SUBSCRIBED'
export const SET_UPDATE = 'TRADES/SET_UPDATE'
export const SET_RECENT_TRADES = 'TRADES/SET_RECENT_TRADES'
export const STOP = 'TRADES/STOP'
